import React, { useEffect } from 'react';
// import GOOGLE_LOGO from "../../assets/le-sso-google.svg";
import { GoogleLogin } from '@react-oauth/google';
import GoogleSSO from '../../assets/google_sso.svg';

import './index.scss';

function Google({ isLogin, successCallback, ssoProvider }) {
  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <div className="gButton">
        <button type="button" className="gButton">
          <div className="gDiv">
            <img src={GoogleSSO} alt="Google" />
          </div>
          <span className="gText">Continue With Google</span>
        </button>
      </div>

      <div className="gButton-new">
        <GoogleLogin
          onSuccess={(credentialResponse) => {
            successCallback(credentialResponse.credential);
          }}
          width="280px"
          onError={() => {
            console.log('Login Failed');
          }}
        />
      </div>
    </div>
  );
}

export default Google;
